import { createTinyHealthApiClient } from '@repo/api-client';
import { urls } from '@repo/app-constants';
import axios from 'axios';
const getEnvironment = () => process.env?.VITE_APP_ENVIRONMENT ||
    import.meta.env?.VITE_APP_ENVIRONMENT ||
    'development';
const getPreviewApiBaseUrl = () => process.env?.VITE_APP_API_BASE_URL || import.meta.env?.VITE_APP_API_BASE_URL;
const getUseSandbox = () => (process.env?.VITE_APP_USE_SANDBOX ||
    import.meta.env?.VITE_APP_USE_SANDBOX) === 'true';
/**
 * Get the API base URL based on environment variables
 */
function getApiBaseUrl() {
    const environment = getEnvironment();
    const previewApiBaseUrl = getPreviewApiBaseUrl();
    const useSandbox = getUseSandbox();
    // Import URLs dynamically to avoid build issues
    const PRODUCTION_API_URL = 'https://api.tinyhealth.com';
    const SANDBOX_API_URL = 'https://sandbox-api.tinyhealth.com';
    const LOCAL_DEVELOPMENT_API_URL = 'http://localhost:3001/sandbox';
    if (environment === 'preview' && !!previewApiBaseUrl) {
        return previewApiBaseUrl;
    }
    if (environment === 'development' && !useSandbox) {
        return LOCAL_DEVELOPMENT_API_URL;
    }
    if (environment === 'preview' || useSandbox) {
        return SANDBOX_API_URL;
    }
    return PRODUCTION_API_URL;
}
/**
 * Fetch features for a main account
 */
export async function fetchFeatures(mainAccountId, options = {}) {
    if (!mainAccountId)
        return {};
    const { token, impersonateId, impersonateKitId } = options;
    const baseUrl = getApiBaseUrl();
    const headers = {};
    // Opt into the v2 features response format (object map). Without this header the backend may return
    // the legacy array format for backward compatibility with older frontend bundles.
    headers['X-Features-Version'] = '2';
    try {
        console.debug('[Features Client] Fetching features:', {
            baseUrl,
            mainAccountId,
            hasToken: !!token,
            hasImpersonateId: !!impersonateId,
        });
        const environment = getEnvironment();
        const previewApiBaseUrl = getPreviewApiBaseUrl();
        const useSandbox = getUseSandbox();
        const apiClient = createTinyHealthApiClient({
            environment,
            previewApiBaseUrl,
            useSandbox,
            sandboxApiUrl: urls.SANDBOX_API_URL,
            localDevelopmentApiUrl: urls.LOCAL_DEVELOPMENT_API_URL,
            defaultApiUrl: baseUrl,
            getToken: () => token || null,
            getImpersonateId: () => impersonateId || null,
            getImpersonateKitId: () => impersonateKitId || null,
        });
        const response = await apiClient.api.get(`${urls.apiBasePath}/features`, undefined, true, headers);
        return response?.data?.result || response?.data || response || {};
    }
    catch (error) {
        console.error('[Features Client] Error fetching features:', error);
        if (axios.isAxiosError(error)) {
            const axiosError = error;
            if (axiosError.response?.status === 401) {
                console.warn('[Features Client] Unauthorized - token may be invalid');
                return {};
            }
            if (axiosError.response?.status === 403) {
                console.warn('[Features Client] Forbidden - insufficient permissions');
                return {};
            }
        }
        // Return empty array for any other errors to be graceful
        return {};
    }
}
/**
 * Extract a specific feature from a list of features
 */
export function getFeature(features, featureName) {
    const feature = features[featureName];
    if (!feature) {
        return {
            isFeatureEnabled: false,
            variables: {},
            variationKey: null,
            source: undefined,
        };
    }
    return {
        isFeatureEnabled: feature.enabled || false,
        variables: feature.variables || {},
        variationKey: feature.variationKey,
        source: feature.source,
    };
}
//# sourceMappingURL=client.js.map